import SubcategoriesItem from './SubcategoriesItem'

export default SubcategoriesItem
